import React from 'react';
import { VTypography } from '@venti-components';

const CardBankTitle = ({ bank }) => {
  // Mapping from server enum values to display names
  const bankTitleMap = {
    ASTROPAY: 'AstroPay',
    BANCO_COINAG: 'Banco Coinag',
    BANCO_COLUMBIA: 'Banco Columbia',
    BANCO_COMAFI: 'Banco Comafi',
    BANCO_CORRIENTES: 'Banco Corrientes',
    BANCO_CREDICOOP: 'Banco Credicoop',
    BANCO_DEL_SOL: 'Banco del Sol',
    BANCO_ENTRE_RIOS: 'Banco Entre Ríos',
    BANCO_HIPOTECARIO: 'Banco Hipotecario',
    BANCO_HSBC: 'Banco HSBC',
    BANCO_ICBC: 'Banco ICBC',
    BANCO_ITAU: 'Banco Itaú',
    BANCO_MACRO: 'Banco Macro',
    BANCO_MUNICIPAL: 'Banco Municipal',
    BANCO_NACION: 'Banco Nación',
    BANCO_PATAGONIA: 'Banco Patagonia',
    BANCO_PIANO: 'Banco Piano',
    BANCO_PROVINCIA: 'Banco Provincia',
    BANCO_SAN_JUAN: 'Banco San Juan',
    BANCO_SANTA_CRUZ: 'Banco Santa Cruz',
    BANCO_SANTA_FE: 'Banco Santa Fe',
    BANCO_SANTANDER: 'Banco Santander',
    BANCO_SUPERVIELLE: 'Banco Supervielle',
    BBVA: 'BBVA Banco Francés',
    BANCOR: 'Bancor',
    BELO: 'Belo',
    BERRY: 'Berry',
    BICA: 'Bica',
    BPN: 'BPN',
    BRUBANK: 'Brubank',
    BUENBIT: 'Buenbit',
    CABAL: 'Cabal',
    CENCOPAY: 'Cencopay',
    CIUDAD: 'Ciudad',
    CLARO_PAY: 'Claro Pay',
    COCOS: 'Cocos',
    COCOS_CRYPTO: 'Cocos Crypto',
    CUENTA_DNI: 'Cuenta DNI',
    DOLAR_APP: 'Dolar App',
    FIWIND: 'Fiwind',
    GALICIA: 'Banco Galicia',
    LEMON: 'Lemon',
    LETSBIT: 'Letsbit',
    NARANJA_X: 'Naranja X',
    OPENBANK: 'Openbank',
    PERSONAL_PAY: 'Personal Pay',
    PLUS_CRYPTO: 'Plus Crypto',
    PREX: 'Prex',
    RIPIO: 'Ripio',
    SATOSHI_TANGO: 'Satoshi Tango',
    TAKENOS: 'Takenos',
    UALA: 'Ualá',
    WALLBIT: 'Wallbit',
    YOY: 'Yoy',
  };

  const bankTitle = bankTitleMap[bank];

  if (!bankTitle) {
    return <VTypography variant="body1">Tarjeta de crédito o débito</VTypography>;
  }

  return <VTypography variant="body1">{bankTitle}</VTypography>;
};

export default CardBankTitle;
